export const contacts = {
  title: "Contacts",
  description: "Everyone who commented or messaged you, one profile per person across channels.",
  search: "Search by name, handle or tag",
  allTags: "All",
  count: "{{n}} contacts",
  columns: {
    name: "Name",
    identities: "Channels",
    tags: "Tags",
    firstSeen: "First seen",
    lastSeen: "Last active",
  },
  empty: "No contacts yet",
  emptyHint: "People appear here when they comment on your posts or send you a message.",
  noResults: "No contacts match",
  noResultsHint: "Try another name, handle or tag.",
  loadMore: "Load more",
  profile: {
    back: "All contacts",
    identities: "Identities",
    identitiesHint: "The same person across channels.",
    activity: "Activity",
    activityHint: "Comments and conversations with this person.",
    noActivity: "No activity yet",
    comments: "Comments",
    conversations: "Conversations",
    sentiment: "Sentiment",
    tags: "Tags",
    tagsLocal: "Tags you add here stay on this device until tag editing reaches the API.",
    addTag: "Add a tag…",
    openInInbox: "Open in inbox",
    firstSeen: "First seen",
    lastSeen: "Last active",
    comment: "Comment",
    dm: "Direct message",
    onPost: "on a post",
    notFound: "This contact doesn't exist",
  },
};
